/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Source_Lot_PlaceholderInputs */

const vi_scl_new_source_lot_placeholder = /** @type {(inputs: Scl_New_Source_Lot_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô phân loại...`)
};

/**

* @param {Scl_New_Source_Lot_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_source_lot_placeholder = /** @type {((inputs?: Scl_New_Source_Lot_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Source_Lot_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_source_lot_placeholder(inputs)
});